import { createAction } from 'redux-actions';
import { Gruser, PapiGruserPage } from '../../types/papi';

export const fetchPrivilegesSuccess = createAction(
  '@@gruser.PRIVILEGES.FETCH.SUCCESS',
  (gruser: Gruser, payload: PapiGruserPage['privileges']) => ({
    ...payload,
    gruser,
  })
);
